var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "download\u5907\u4EFD 4@4x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5B98\\u7F51\\u91CD\\u6784\\uFF08\\u4E8C\\u671F\\uFF09",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12-\\u8D44\\u6599\\u4E0B\\u8F7D",
    transform: "translate(-1508.000000, -361.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(654.000000, 359.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "download\\u5907\\u4EFD-4",
    transform: "translate(862.000000, 10.000000) scale(-1, 1) translate(-862.000000, -10.000000) translate(854.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "upload",
    transform: "translate(1.066696, 2.400000)",
    fill: "currentColor",
    fillOpacity: 0.92
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.333336,4.666608 L1.333336,9.333304 L12.000024,9.333304 L12.000024,4.666608 L13.333304,4.666608 L13.333304,9.333304 C13.333304,10.068584 12.735304,10.666584 12.000024,10.666584 L12.000024,10.666584 L1.333336,10.666584 C0.598,10.666584 0,10.068584 0,9.333304 L0,9.333304 L0,4.666608 L1.333336,4.666608 Z M7.333304,0 L7.333304,4.666688 L9.333304,4.666688 L6.666664,8.000024 L4,4.666688 L6,4.666688 L6,0 L7.333304,0 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.891a6e04.svg";
export { ForwardRef as ReactComponent };